module.exports = __webpack_public_path__ + "img/sticker_logo.b9189270.png";